module.exports = "/build/web/svg/icon-chevron-right--dark.6d9927c519f19e174ecb880c924d4698.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/icon-chevron-right--dark.svg
// module id = 117
// module chunks = 13